/* This file is autogenerated, see readme.md for instructions */
import AxisSvgIcon from '@bloomreach/banana-theme/icons/axis.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const AxisIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <AxisSvgIcon />
    </Icon>
  );
});

AxisIcon.displayName = 'AxisIcon';

export default AxisIcon;
